import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { initialize, LDClient, LDFlagSet } from "launchdarkly-js-client-sdk";
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private ldClient: LDClient;
  private flags: LDFlagSet;
  private thisCallback: any = null;

  constructor() {
    this.flags = { 'checkout': false };
  }

  featureOff(featureName: string) {
    // Read the value from the config service
    if (environment.features.hasOwnProperty(featureName)) {
      return !environment.features[featureName];
    }
    return true; // if feature not found, default to turned off
  }

  featureOn(featureName: string) {
    return !this.featureOff(featureName);
  }

  /**
   * Init the lauchDarkly service with a merchant and if want anonymous session
   * @param merchantUser The id of merchant to get flags active for these
   * @param isAnonymous sets if want not register the session 
   */
  initFlags(merchantUser: string): Observable<any> {
    return new Observable((observer) => {
      try {
        this.ldClient = initialize(environment.ld_api_checkout, { key: merchantUser });
        this.ldClient.on('ready', () => {

          this.setFlags();
          observer.next();
          if (this.thisCallback != null) {
            this.thisCallback();
          }
        });
        this.ldClient.on('change', () => {
          this.setFlags();
          observer.next();
          if (this.thisCallback != null) {
            this.thisCallback();
          }
        });

      } catch (error) {

        observer.error(error);
      }
    });
  }

  /**
 * Sets all the keys disposed by launch Darkly proyect
 */
  private setFlags() {
    this.flags = this.ldClient.allFlags();
  }

  /**
   * 
   * @param callback Function to call when the launch darkly has init
   */
  public setFunctionThen(callback: any) {
    this.thisCallback = callback;
  }

  /**
   * This functions query in LaunchDarkly if exist the key
   * @param featureFlag The name of the flag to query his value
   * @returns if the flag exist return the value of the flag else return null;
   */
  getFlagValue(featureFlag: string) {
    if (this.flags.hasOwnProperty(featureFlag)) {
      return this.flags[featureFlag];
    }
    return null;
  }

}